// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PdpRespDetails__wrapper__96db6f52","header":"PdpRespDetails__header__96db6f52"};